// 搜索栏获取参数
class searchReq {
    public pageNo: number;
    public pageSize: number;               
    public state: string;   
    public recUniversity: string;
    public startDate: string;
    public jobName: string;

    constructor(){
        this.pageNo = 1;
        this.pageSize = 20;
        this.startDate = '';
        this.state = '';
        this.recUniversity = '';
        this.startDate = '';
        this.jobName = '';
    }
}

// 简历列表搜索栏参数
class summarygReq {
    public pageNo: number;
    public pageSize: number;               
    public university : string;
    public executeState : string;

    constructor(){
        this.pageNo = 1;
        this.pageSize = 20;
        this.university = '';
        this.executeState = '';
    }
}
// 列表请求参数
class normalReq {
    public pageNo: number;
    public pageSize: number;               
    public itineraryId: string;               


    constructor(){
        this.pageNo = 1;
        this.pageSize = 200;
        this.itineraryId = "";
    }
}


// 招聘情况参数
class recruitmentForm {
    public itineraryId: any;
    public speechTime: any;           
    public university: string;   
    public provinces: string;
    public address: string;
    public speecherName: string;
    public entourage: string;
    public checkinNumber: string;
    public attendanceNumber: string;
    public resumeNumber: string;
    public interviewNumber: string;
    public interviewPassNumber: string;
    public signNumber: string;
    public registerNumber: string;

    constructor(){
        this.speechTime = '';
        this.university = '';
        this.itineraryId = ''; 
        this.provinces = '';
        this.address = '';
        this.speecherName = '';
        this.entourage = '';
        this.checkinNumber = '';
        this.attendanceNumber = '';
        this.resumeNumber = '';
        this.interviewNumber = '';
        this.interviewPassNumber = '';
        this.signNumber = '';
        this.registerNumber = '';
    }
}

// 费用汇总参数
class costForm {
    public itineraryId: any;
    public statisticsId: string;           
    public statisticsName: string;   
    public useTime: any;   
    public users: string;
    public reason: string;
    public feeStall: string;
    public feeGift: string;
    public feeTraffic: string;
    public feeLodging: string;
    public feeDining: string;
    public feePlatform: string;
    public feeMaterial: string;
    public singleSum: string;

    constructor(){
        this.statisticsId = '';
        this.statisticsName = '';
        this.useTime = '';
        this.itineraryId = ''; 
        this.users = '';
        this.reason = '';
        this.feeStall = '';
        this.feeGift = '';
        this.feeTraffic = '';
        this.feeLodging = '';
        this.feeDining = '';
        this.feePlatform = '';
        this.feeMaterial = '';
        this.singleSum = '';
    }
}
// 费用汇总参数
class communicationForm {
    public itineraryId: any;
    public id: any;
    public visitorId: string;           
    public visitorName: string;   
    public teacher: string;
    public job: string;
    public contact: string;
    public office: string;
    public content: string;
    public gift: string;
    constructor(){
        this.visitorId = '';
        this.visitorName = '';
        this.id = ''; 
        this.itineraryId = ''; 
        this.teacher = '';
        this.job = '';
        this.contact = '';
        this.office = '';
        this.content = '';
        this.gift = '';
    }
}


// 交流情况参数
class dataAnalysisForm {
    public id: any;
    public itineraryId: any;
    public ratePropagate: string;           
    public rateSpeech: string;   
    public ratePass: string;
    public rateSign: string;
    public rateRegister: string;
    constructor(){
        this.ratePropagate = '';
        this.rateSpeech = '';
        this.id = ''; 
        this.itineraryId = ''; 
        this.ratePass = '';
        this.rateSign = '';
        this.rateRegister = '';

    }
}


export {
    searchReq,
    recruitmentForm,
    summarygReq,
    costForm,
    communicationForm,
    dataAnalysisForm,
    normalReq
}